import { useRouteError } from "react-router-dom"

export default function ErrorBoundary() {
  let error = useRouteError()
  const errorMessage: any = error ? error : "you have hit an error"
  console.error(error)
  // Uncaught ReferenceError: path is not defined
  return <div>Dang! {errorMessage}</div>
}
